import { ComponentPropsWithRef } from 'react';

import { cn } from '@codes/ui-kit/utils';

type SpinnerProps = ComponentPropsWithRef<'svg'>;

export const Spinner = ({ className, ...props }: SpinnerProps) => {
    return (
        <svg
            viewBox="0 0 36 36"
            className={cn('animate-spin stroke-primary stroke-2 w-12 aspect-square', className)}
            {...props}
        >
            <circle
                cx="18"
                cy="18"
                r="15.9155"
                strokeDasharray="75, 25"
                strokeLinecap="round"
                transform="rotate(-90 18 18)"
                className="fill-none stroke-inherit"
            />
        </svg>
    );
};
